import React from 'react';
import { Link } from 'react-router-dom';
import styles from './bodywon.module.css';

const sortCurrentProductFirst = (products, currentProductId) => (
  [...products].sort((a, b) => {
    if (a.id === currentProductId) return -1;
    if (b.id === currentProductId) return 1;
    return 0;
  })
);

const FrequentlyBoughtTogether = ({ bundles, currentProductId, onAddBundle, formatPrice }) => {
  if (!bundles?.length) return null;

  const handleAddAll = async (bundle) => {
    await onAddBundle?.(bundle);
  };

  return (
    <>
      {bundles.map((bundle) => {
        const products = sortCurrentProductFirst(bundle.products, currentProductId);

        return (
          <section key={bundle.bundleProductId} className={styles.fbtSection}>
            <h2 className={styles.fbtTitle}>Frequently bought together</h2>
            <div className={styles.fbtLayout}>
              <div className={styles.fbtProducts}>
                {products.map((item, index) => (
                  <React.Fragment key={item.id}>
                    {index > 0 ? <span className={styles.fbtPlus} aria-hidden="true">+</span> : null}
                    <div className={styles.fbtItem}>
                      <Link to={`/product/${item.id}`} className={styles.fbtImageLink}>
                        {item.imageSrc ? (
                          <img src={item.imageSrc} alt={item.name} />
                        ) : (
                          <div className={styles.fbtImagePlaceholder} />
                        )}
                      </Link>
                      <div className={styles.fbtItemInfo}>
                        <Link to={`/product/${item.id}`} className={styles.fbtProductName}>
                          {item.id === currentProductId ? (
                            <span className={styles.fbtThisItem}>This item: </span>
                          ) : null}
                          {item.name}
                        </Link>
                        <div className={styles.fbtItemPrice}>{formatPrice(item.price)}</div>
                      </div>
                    </div>
                  </React.Fragment>
                ))}
              </div>
              <div className={styles.fbtSummary}>
                <p className={styles.fbtTotal}>
                  Total price: <strong>{formatPrice(bundle.price)}</strong>
                </p>
                <button
                  type="button"
                  className={styles.fbtAddAllBtn}
                  onClick={() => handleAddAll(bundle)}
                >
                  {`Add all ${products.length} to Cart`}
                </button>
              </div>
            </div>
          </section>
        );
      })}
    </>
  );
};

export default FrequentlyBoughtTogether;
